// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"bb43b460","994":"7dc2a5dd"}[chunkId] + ".chunk.css";
};